import { Email } from "@mui/icons-material";
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router";

export const NewsletterUserProfileButton = () => {
  const { t } = useTranslation();  
  const navigate = useNavigate();

  return {
    label: t("common:text.newsletter_manage"),
    icon: <Email />,
    onClick: () => navigate(t('common:url.newsletter'))
  }
}

export default NewsletterUserProfileButton;